export const CREATE_BOOKING = '/api/CustomerAnalytics/createRetailBooking';
export const GET_ORGANISATION_DETAILS = '/api/CustomerAnalytics/orgdetails';
export const FETCH_CITY_LIST = '/api/customeranalytics/areacode/cities/fetch';
export const FETCH_AREA_CODES = '/api/customeranalytics/areacode/fetch';
export const FETCH_SERVICE_TYPES = '/api/customeranalytics/getServiceTypes';

export const REGISTER_APP_USER = '/api/CRMDashboard/workerenrollment/request/create';
export const GET_S3_SIGNED_URL = '/api/Dashboard/workerenrollment/generateImageUrl';
export const GET_APP_USER_OTP = '/api/CustomerAnalytics/generateOtp';
export const VERIFY_APP_USER_OTP = '/api/CustomerAnalytics/verifyOTP';